/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { useI18n } from "intl/useI18n";
import { useDtfStore } from "../store";
import MultiSizeTotalSummary from "./MultiSizeTotalSummary.vue";
import "./MultiSizeTotal.scss";

export default function MultiSizeTotal({ index = 0, isMultiUpload = false, ...restProps }) {
  const { t, n } = useI18n();
  const store = useDtfStore();

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  // @ts-expect-error TS(6133): 'summary' is declared but its value is never read.
  function summary() {
    // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
    return store.summary;
  }

  function simulation() {
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    return store.simulation;
  }

  function isPricingLoading() {
    // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
    return store.isPricingLoading;
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return store.enableAbAiMonetization;
  }

  function getBogoAdjustedPrice() {
    // @ts-expect-error TS(4111): Property 'getBogoAdjustedPrice' comes from an inde... Remove this comment to see the full error message
    return store.getBogoAdjustedPrice;
  }

  function artwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks()[index];
  }

  function isArtworkUploaded() {
    const artworkId = parseInt(artwork()?.id, 10);
    if (Number.isNaN(artworkId)) {
      return false;
    }
    return typeof artworkId === "number" && !artwork()?.isLoading;
  }

  function showPricing() {
    return index === 0 || isArtworkUploaded();
  }

  function sizesAndQuantities() {
    return artwork()?.sizesAndQuantities || [];
  }

  function sizesCount() {
    return sizesAndQuantities().length;
  }

  function quantity() {
    return sizesAndQuantities().reduce((acc: any, curr: any) => acc + Number(curr.quantity), 0);
  }

  function pricing() {
    if (artwork()?.isFile || !sizesAndQuantities().some((sq: any) => Number(sq.quantity) > 0)) {
      return simulation();
    }
    return sizesAndQuantities() || simulation();
  }

  function retailTotal() {
    return getPrice("retailPrice");
  }

  function total() {
    return getPrice("unitPrice");
  }

  function discount() {
    const retail = parseFloat(retailTotal());
    const actual = parseFloat(total());
    if (!retail || !actual) return 0;
    return Math.ceil(((retail - actual) / retail) * 100).toFixed(0);
  }

  function getPrice(propertyName: any) {
    if (Array.isArray(pricing())) {
      const artworkId = String(artwork()?.id ?? "");
      return pricing()
        .reduce((sum: any, item: any) => {
          if (propertyName === "unitPrice" && artworkId) {
            const sizeKey = `${item.width}x${item.height}`;
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            const bogoPrice = getBogoAdjustedPrice()(artworkId, item.id, sizeKey);
            if (bogoPrice) {
              return sum + bogoPrice.discountedTotalPrice;
            }
          }
          const price = Number(item[propertyName] || 0);
          return sum + price * item.quantity;
        }, 0)
        .toFixed(2);
    }
    return pricing()[propertyName]
      ? // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
        Number(pricing()[propertyName]).toFixed(2) * pricing().quantity
      : null;
  }

  return (
    <>
      {!isMultiUpload && enableAbAiMonetization() ? (
        <MultiSizeTotalSummary
          {...restProps}
          index={index}
          data-testid="multi-size-total-summary"
        />
      ) : pricing() ? (
        <div
          {...restProps}
          // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
          className={cn("multi-size-total", restProps?.className, {
            "multi-size-total--multi-upload": isMultiUpload
          })}
        >
          <div className="multi-size-total__container">
            <div className="multi-size-total__label multi-size-total__label--total">Total</div>
            {sizesCount() > 0 ? (
              <div className="multi-size-total__label multi-size-total__label--sizes">
                {" "}
                for {t("transfer", quantity())}
              </div>
            ) : null}
          </div>
          {sizesCount() > 0 && total() && showPricing() ? (
            <div
              className={cn("multi-size-total__container multi-size-total__container--horizontal", {
                "multi-size-total__container--loading": isPricingLoading() || total() === 0
              })}
            >
              <div className="multi-size-total__label">{n(total(), "currency")}</div>
              {/* @ts-expect-error TS migration */}
              {retailTotal() && discount() > 0 ? (
                <div className="multi-size-total__label multi-size-total__label--strike-of">
                  {n(retailTotal(), "currency")}
                </div>
              ) : null}
              {/* @ts-expect-error TS migration */}
              {discount() > 0 ? (
                <div className="multi-size-total__label multi-size-total__label--discounted">
                  {discount()}% off{" "}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
